export const configurationsTypes = {
  SET_CONFIGURATIONS: 'SET_CONFIGURATIONS',
  GET_CONFIGURATIONS_REQUEST: 'GET_CONFIGURATIONS_REQUEST',
  UPDATE_CONFIGURATION_REQUEST: 'UPDATE_CONFIGURATION_REQUEST'
};
